import { IImage, THrefLink, TSubtitle, TTextWithIcon } from "./common";

export enum FeaturesComponent {
  HomeHeroSearchBar = "features.home-hero-search-bar",
  ContentWithImageSection = "features.content-with-image-section",
  GridCard = "features.grid-card",
}

export type THomeHeroSearchBar = {
  id: number;
  skillsPlaceholder?: string;
  skillsSearchPlaceholder?: string;
  locationsPlaceholder?: string;
  locationsSearchPlaceholder?: string;
  buttonLabel: string;
  __component: FeaturesComponent.HomeHeroSearchBar;
}

export type TContentWithImageSection = {
  id: number;
  title: string;
  imageDesktop: IImage;
  imageMobile: IImage;
  description?: string;
  subtitle?: TSubtitle;
  button?: THrefLink;
  direction: "ltr" | "rtl";
  features?: TTextWithIcon[];
  __component: FeaturesComponent.ContentWithImageSection;
}

export type TGridCard = {
  id: number;
  title: string;
  cardNumber?: number;
  description?: string;
  image?: IImage;
}